"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareableCache = void 0;
const cacheV2_1 = require("../cacheV2");
class ShareableCache extends cacheV2_1.CacheV2 {
    constructor(store) {
        super(store);
        this.shareableStore = store;
    }
    setInitialData(data, cacheLiveTime) {
        Object.keys(data).forEach(key => {
            this.setCached(key, data[key], cacheLiveTime);
        });
    }
    getInitialData() {
        const data = {};
        const length = this.shareableStore.getLength() || 0;
        for (let i = 0; i < length; i++) {
            const key = this.shareableStore.getKey(i);
            if (key) {
                data[key] = this.shareableStore.getItem(key);
            }
        }
        return data;
    }
}
exports.ShareableCache = ShareableCache;
//# sourceMappingURL=shareableCache.js.map